module.exports = "<p>{{announcementId}}</p>"